var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iframe-canvas-wrapper"},[_c('IframeCanvas',{on:{"loaded":function($event){return _vm.$emit('loaded')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }